import { authHeader, handleResponse } from "../helpers";

export const paymentTransactionSettingService = {
  createSetting,
  updateSetting,
  fetchSettingData,
};

function createSetting(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Mapping/NewPaymentSetting`,
    requestOptions
  ).then(handleResponse);
}

function updateSetting(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Mapping/NewPaymentSetting`,
    requestOptions
  ).then(handleResponse);
}

function fetchSettingData(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Mapping/GetPaymentSetting`,
    requestOptions
  ).then(handleResponse);
}
